module.exports = __webpack_public_path__ + "img/laptop.7b658a26.svg";